import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCapIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-dark text-white pt-16 pb-8" data-id="element-102">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-104">
          {/* Brand Col */}
          <div className="col-span-1 md:col-span-1" data-id="element-105">
            <Link to="/" className="flex items-center mb-4" data-id="element-106">
              <GraduationCapIcon className="h-8 w-8 text-gold mr-2" data-id="element-107" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-108">
                OnlineCollege<span className="text-gold" data-id="element-109">Guide</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-110">
              Empowering students to find the perfect online degree program to
              advance their careers and achieve their goals.
            </p>
          </div>

          {/* Links Col 1 */}
          <div data-id="element-111">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-112">
              Top Programs
            </h3>
            <ul className="space-y-3" data-id="element-113">
              <li data-id="element-114">
                <Link to="/degrees/business" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-115">
                  Business Administration
                </Link>
              </li>
              <li data-id="element-116">
                <Link to="/degrees/computer-science" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-117">
                  Computer Science
                </Link>
              </li>
              <li data-id="element-118">
                <Link to="/degrees/healthcare" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-119">
                  Nursing & Healthcare
                </Link>
              </li>
              <li data-id="element-120">
                <Link to="/degrees/psychology" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-121">
                  Psychology
                </Link>
              </li>
            </ul>
          </div>

          {/* Links Col 2 */}
          <div data-id="element-122">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-123">
              Resources
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-124">
              <li data-id="element-125">
                <Link to="/colleges" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-126">
                  Partner Colleges
                </Link>
              </li>
            </ul>
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-127">
              Guides
            </h3>
            <ul className="space-y-3" data-id="element-128">
              <li data-id="element-129">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-130">
                  Financial Aid Guide
                </Link>
              </li>
              <li data-id="element-131">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-132">
                  Accreditation Info
                </Link>
              </li>
              <li data-id="element-133">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-134">
                  Career Paths
                </Link>
              </li>
              <li data-id="element-135">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-136">
                  Student Success Stories
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Col */}
          <div data-id="element-137">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-138">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-139">
              <li data-id="element-140">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-141">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-142">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-143">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-144">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-145">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-146">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-147">
                  Do Not Sell My Info
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8" data-id="element-148">
          <div className="text-xs text-gray-400 space-y-4 text-center md:text-left" data-id="element-149">
            <p data-id="element-150">
              <strong data-id="element-151">Advertiser Disclosure:</strong> OnlineCollegeGuide.com is
              an advertising-supported site. Featured or trusted partner
              programs and all school search, finder, or match results are for
              schools that compensate us. This compensation does not influence
              our school rankings, resource guides, or other
              editorially-independent information published on this site.
            </p>
            <p data-id="element-152">
              <strong data-id="element-153">TCPA Disclosure:</strong> By submitting your information
              on this website, you consent to be contacted by our educational
              partners regarding their programs via email, telephone, or text
              message.
            </p>
            <p className="pt-4 text-gray-500" data-id="element-154">
              &copy; {currentYear} OnlineCollegeGuide. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}